import React from "react";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../../components/grid-container/GridContainer";
import step1Img from '../../../../../styles/img/knw-step-1.png';
import step2Img from '../../../../../styles/img/knw-step-2.png';
import step3Img from '../../../../../styles/img/knw-step-3.png';

export const KnowledgeHowToEarn = (props) => {
    return (
        <>

            <UiContentWr>
                <UiRowContainer fluid="fluid">
                    <UiContentCol>
                        <div className="sb-knowledge-points">
                            <UiCardTitle title="How to earn Knowledge Points" />
                            <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>

                            <UiSingleRow>
                                <div className="sb-knowledge-points__col">
                                    <img src={step1Img} />
                                    <h4>Step 1</h4>
                                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco </p>
                                </div>

                                <div className="sb-knowledge-points__col">
                                    <img src={step2Img} />
                                    <h4>Step 2</h4>
                                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco </p>
                                </div>

                                <div className="sb-knowledge-points__col">
                                    <img src={step3Img} />
                                    <h4>Step 3</h4>
                                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco </p>
                                </div>
                            </UiSingleRow>
                        </div>
                    </UiContentCol>
                </UiRowContainer>
            </UiContentWr>
        </>
    )
}